<template>
  <div class="content_box">
    <van-cell-group>
      <van-cell>
        <van-field v-model="phoneNumber" type="tel" label="手机号" placeholder="请输入手机号" />
      </van-cell>
      <van-cell>
        <van-field v-model="code" center clearable label="短信验证码" placeholder="请输入短信验证码">
          <template #button>
            <van-button v-if="show" @click="sendCodeBeforeBind" size="small" type="primary">发送验证码</van-button>
            <div v-else>{{times}}s</div>
          </template>
        </van-field>
      </van-cell>
    </van-cell-group>
    <div class="recharge_btn" @click="bindAccount">立即绑定</div>
    <div class="actingCapture" @click="toActingCapture">电费代缴（无需绑定）</div>
  </div>
</template>

<script>
import { sendCodeBeforeBind, bindAccount } from "@/api/user.js";
import Vue from "vue";
import { Field } from "vant";
import { Cell, CellGroup, Button } from "vant";
import { Notify } from "vant";
import { setToken, getToken } from "@/libs/util.js";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Button);
export default {
  data() {
    return {
      code: "",
      times: 60,
      show: true,
      phoneNumber: "",
      url: config.url,
      appId: config.appId
    };
  },
  mounted() {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function() {
      history.pushState(null, null, document.URL);
    });
  },
  methods: {
    toActingCapture() {
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
        this.appId
      }&redirect_uri=${encodeURIComponent(this.url)}${encodeURIComponent(
        "tcmr/actingCapture"
      )}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`;
    },
    bindWx() {},
    getCode() {
      this.show = false;
      this.timer = setInterval(() => {
        this.times--;
        if (this.times === 0) {
          this.times = 60;
          this.show = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    isPoneAvailable(pone) {
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(pone)) {
        return false;
      } else {
        return true;
      }
    },
    sendCodeBeforeBind() {
      if (this.phoneNumber) {
        sendCodeBeforeBind(this.phoneNumber).then(res => {
          if (res.data.status == 200) {
            this.getCode();
            Notify({ type: "success", message: "验证码发送成功！" });
          } else {
            Notify({ type: "danger", message: res.data.msg });
          }
        });
      } else {
        Notify({ type: "danger", message: "请先输入手机号！" });
      }
    },
    bindAccount() {
      if (!this.phoneNumber) {
        Notify({ type: "danger", message: "请先输入手机号！" });
        return;
      }
      if (!this.isPoneAvailable(this.phoneNumber)) {
        Notify({ type: "danger", message: "请输入合法的手机号！" });
        return;
      }
      if (!this.code) {
        Notify({ type: "danger", message: "请先获取手机验证码！" });
        return;
      }
      bindAccount({
        openid: localStorage.getExpire("openId"),
        phoneNumber: this.phoneNumber,
        code: this.code
      }).then(res => {
        if (res.data.status == 200) {
          setToken(res.data.object);
          Notify({ type: "success", message: "注册成功" });
          this.$router.push({
            path: "/tcmr/home"
          });
          this;
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    }
  }
};
</script>

<style scoped>
.actingCapture {
  color: #008c65;
  font-size: 0.24rem;
}
.recharge_btn {
  color: #fff;
  height: 0.6rem;
  font-size: 0.26rem;
  line-height: 0.6rem;
  margin: 0rem 0.3rem;
  margin-top: 0.3rem;
  background: #50c7a1;
  border-radius: 0.06rem;
}
</style>